import React from 'react';
import { Row } from 'react-table';

import { formatNumberCompact } from '@trqk/utils';

import { footerHeight, COLUMN_IDS, summarizeRowsAbove } from '../../constants';
import { sumIncludedDetections } from '../../utils';

interface WorkGapFooterProps {
    groupedRows: Row<TrqkGapChannelAudio>[];
    rows: Row<TrqkGapChannelAudio>[];
}

/**
 * Sums and displays the total of all gaps (differences between the performances and detections) for
 * all rows that are currently selected.
 * @param props - {@link WorkGapFooterProps}
 */
export function WorkGapFooter({
    groupedRows,
}: WorkGapFooterProps): JSX.Element {
    const gapSum = groupedRows.reduce(
        (acc: number, row: Row<TrqkGapChannelAudio>): number => {
            if (row.isSelected || row.isSomeSelected) {
                if (row.subRows.length > summarizeRowsAbove) {
                    const detections = sumIncludedDetections(row.subRows);
                    const performances =
                        row.values?.[COLUMN_IDS.PERFORMANCES]?.performances ??
                        0;

                    const rowGap = detections - performances;

                    return acc + rowGap;
                }

                return acc + row.values?.[COLUMN_IDS.GAP] ?? 0;
            }

            return acc;
        },
        0,
    );

    return (
        <p className="flex items-center pl-1" style={{ height: footerHeight }}>
            {formatNumberCompact(gapSum)}
        </p>
    );
}
